import sectionFaqGrid03Css from '../css-snippets/section-faq-grid-03';

const html = `
<style>${sectionFaqGrid03Css}</style>
<div
  data-container="faq-grid-container-fluid-unique-id"
  data-id="unique-id"
  data-attribute="faq-grid-container-fluid"
  data-top-padding="true"
  data-bottom-padding="true"
  class="faq-grid-container-fluid"
  data-container-full-width="true"
>
  <div data-attribute="faq-grid-container" class="faq-grid-container container">
    <div data-attribute="title-faq-grid" class="title-faq-grid">
      <h2 style="text-align: center">
        <strong>Questions from Homeowners</strong>
      </h2>
    </div>
    <div
      data-attribute="list-item"
      class="list-item"
    >
      <div
        data-attribute="item-wapper"
        class="item-wapper"
      >
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            How is Haven different from my current detector?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m18 15-6-6-6 6" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            Most detectors only show a green light — which stays on even when
            the sensor is dead. They don't alarm until 70 PPM, which is AFTER
            1-4 hours of exposure. Haven shows you real-time levels from 0 PPM
            on a digital display. You see the truth, not a light that lies.
          </div>
        </div>
      </div>
      <div
        data-attribute="item-wapper"
        class="item-wapper"
      >
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            Will it false alarm when I cook?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m18 15-6-6-6 6" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            No. Haven uses professional-grade electrochemical sensors — the same
            type used in industrial settings. They detect real threats, not
            toast or shower steam.
          </div>
        </div>
      </div>
      <div
        data-attribute="item-wapper"
        class="item-wapper"
      >
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            Does Haven detect propane and natural gas, or just carbon monoxide?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m18 15-6-6-6 6" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            Haven is a 4-in-1 detector. It monitors carbon monoxide, natural
            gas, AND propane, plus temperature and humidity. This is a critical
            distinction. Most cheap detectors from the hardware store only
            detect CO. If your stove leaks natural gas, your furnace has a
            propane leak, or your water heater line is compromised, those
            detectors stay completely silent. Haven catches all three gas
            threats in real-time, with PPM readings on the display starting at
            0. One unit. Complete protection. No gaps.
          </div>
        </div>
      </div>
      <div
        data-attribute="item-wapper"
        class="item-wapper"
      >
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            Where should I install Haven? Does height or outlet position matter?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m18 15-6-6-6 6" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            Haven plugs into any standard wall outlet, no ladder, no tools, no
            electrician. 30 seconds and you're protected. For placement, focus
            on two priorities: near gas appliances (furnaces, stoves, water
            heaters) and in hallways outside bedrooms where your family sleeps.
            Haven's sensors are calibrated to detect all three regardless of
            outlet height. Most families start with one near the furnace/water
            heater, one in the kitchen near the stove, and one in the hallway
            outside bedrooms. The 4-Pack covers most homes completely.
          </div>
        </div>
      </div>
      <div
        data-attribute="item-wapper"
        class="item-wapper"
      >
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            Is it hard to install?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m18 15-6-6-6 6" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            No. Plug it into any eye-level outlet. That's it. Takes 30 seconds.
            No ladder, no tools, no electrician.
          </div>
        </div>
      </div>
      <div
        data-attribute="item-wapper"
        class="item-wapper"
      >
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            How many do I need?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m18 15-6-6-6 6" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            One per floor + near bedrooms + near gas appliances (furnace, water
            heater, garage). Most homes need 4. Apartments typically need 2.
          </div>
        </div>
      </div>
      <div
        data-attribute="item-wapper"
        class="item-wapper"
      >
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            Can I use it if I live alone?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m18 15-6-6-6 6" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            Yes! Haven is perfect for people who live alone. It watches 24/7 and
            will alert you to danger even while you're sleeping. Many of our
            customers are seniors who live independently and wanted peace of
            mind.
          </div>
        </div>
      </div>
      <div
        data-attribute="item-wapper"
        class="item-wapper"
      >
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            What if it doesn't work for me?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m18 15-6-6-6 6" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            You're covered by our 100-Day "Sleep in Peace" Guarantee. If you're
            not satisfied for any reason, we'll refund every penny. No
            questions. Plus, the Lifetime Guarantee means we replace it free if
            anything ever goes wrong.
          </div>
        </div>
      </div>
      <div
        data-attribute="item-wapper"
        class="item-wapper"
      >
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            My detector is hardwired. Isn't that better?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m18 15-6-6-6 6" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            Hardwired means it runs on electricity — but the SENSOR inside still
            expires after 5-7 years. The green light stays on even when the
            sensor is dead. Haven plugs in and shows you a real number, so you
            always know it's working.
          </div>
        </div>
      </div>
      <div
        data-attribute="item-wapper"
        class="item-wapper"
      >
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            How fast will I receive it?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m18 15-6-6-6 6" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            Ships from US warehouse. 3-5 business days typically.
          </div>
        </div>
      </div>
      <div
        data-attribute="item-wapper"
        class="item-wapper"
      >
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            What if it doesn't work?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m18 15-6-6-6 6" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            90 days. Full refund. Keep everything. Zero risk.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
